export * from './SelectedMaterialsSidebarAttachModalButton.types';
export { default as SelectedMaterialsSidebarAttachModalButton } from './SelectedMaterialsSidebarAttachModalButton';
